/*
Author: Gilang Romadhanu Tartila
*/

export const SET_LOADING = 'SET_LOADING';
export const SET_RESOURCES = 'SET_RESOURCES';

import { getUniqeItem } from '@global/helpers';

import store from '@/store';

import { MsOrder } from '@api/ms-order';
import { MsAccount } from '@api/ms-account';
import { MsB2b } from '@api/ms-b2b';
import { MsCatalog } from '@api/ms-catalog';

const changeResourcesData = (name, data, isLoadMore) => {
  return { type: SET_RESOURCES, name: name, data: data, more: isLoadMore };
};

export const getSalesTeams = ({
  isLoadMore = false,
  filter = {},
  skip = 0,
  limit = 50,
  force = false,
}) => {
  return async (dispatch) => {
    if (
      (!(
        store.getState().resources.salesTeams &&
        store.getState().resources.salesTeams.length
      ) ||
        force) &&
      !store.getState().resources.loading.salesTeams
    ) {
      dispatch({ type: SET_LOADING, name: 'salesTeams', data: true });
      let result = [];
      const payload = {
        params: {
          skip: skip,
          limit: limit,
        },
      };
      if (filter && Object.keys(filter).length) {
        payload.params.filter = filter;
      }
      const response = await MsB2b.getSalesTeam(payload);
      if (response?.data?.data?.length) {
        result = response.data.data.map((item) => {
          if (item._id) {
            item.id = item._id;
          }
          return item;
        });
      }
      dispatch(changeResourcesData('salesTeams', result, isLoadMore));
      dispatch({ type: SET_LOADING, name: 'salesTeams', data: false });
      return result;
    }
    return [];
  };
};

export const getBranches = ({
  isLoadMore = false,
  filter = {},
  skip = 0,
  limit = 50,
  force = false,
}) => {
  return async (dispatch) => {
    if (
      (!(
        store.getState().resources.branches &&
        store.getState().resources.branches.length
      ) ||
        force) &&
      !store.getState().resources.loading.branches
    ) {
      dispatch({ type: SET_LOADING, name: 'branches', data: true });
      let result = [];
      const payload = {
        params: {
          skip: skip,
          limit: limit,
        },
      };
      if (filter && Object.keys(filter).length) {
        payload.params.filter = filter;
      }
      const response = await MsAccount.getBranches(payload);
      if (response?.data?.data?.length) {
        result = response.data.data.map((item) => {
          if (item._id) {
            item.id = item._id;
          }
          return item;
        });
      }
      dispatch(changeResourcesData('branches', result, isLoadMore));
      dispatch({ type: SET_LOADING, name: 'branches', data: false });
      return result;
    }
    return [];
  };
};

export const getWarehouses = ({
  isLoadMore = false,
  filter = {},
  skip = 0,
  limit = 50,
  force = false,
}) => {
  return async (dispatch) => {
    if (
      (!(
        store.getState().resources.warehouses &&
        store.getState().resources.warehouses.length
      ) ||
        force) &&
      !store.getState().resources.loading.warehouses
    ) {
      dispatch({ type: SET_LOADING, name: 'warehouses', data: true });
      let result = [];
      const payload = {
        params: {
          skip: skip,
          limit: limit,
        },
      };
      if (filter && Object.keys(filter).length) {
        payload.params.filter = filter;
      }
      const response = await MsOrder.getWarehouse(payload);
      if (response?.data?.data?.length) {
        result = response.data.data.map((item) => {
          if (item._id) {
            item.id = item._id;
          }
          return item;
        });
      }
      dispatch(changeResourcesData('warehouses', result, isLoadMore));
      dispatch({ type: SET_LOADING, name: 'warehouses', data: false });
      return result;
    }
    return [];
  };
};

export const getMarketTypes = ({
  isLoadMore = false,
  filter = {},
  skip = 0,
  limit = 50,
  force = false,
  isAll = false,
}) => {
  return async (dispatch) => {
    if (
      (!(
        store.getState().resources.marketTypes &&
        store.getState().resources.marketTypes.length
      ) ||
        force) &&
      !store.getState().resources.loading.marketTypes
    ) {
      dispatch({ type: SET_LOADING, name: 'marketTypes', data: true });
      let result = [];
      const payload = {
        params: {
          skip: skip,
          limit: limit,
          sort: '-created_at',
        },
      };
      if (filter && Object.keys(filter).length) {
        payload.params.filter = filter;
      }
      if (isAll) {
        delete payload.params.limit;
        delete payload.params.skip;
      }
      const apiCall = isAll ? MsB2b.getAllMarketType : MsB2b.getMarketType;
      const response = await apiCall(payload);
      if (response?.data?.data?.length) {
        result = getUniqeItem(response.data.data, 'code').map((item) => {
          if (item._id) {
            item.id = item._id;
          }
          if (item?.business_type?.length) {
            item.business_type = item.business_type.map((child) => {
              if (child._id) {
                child.id = child._id;
              }
              return child;
            });
          }
          return item;
        });
      }
      dispatch(changeResourcesData('marketTypes', result, isLoadMore));
      dispatch({ type: SET_LOADING, name: 'marketTypes', data: false });
      return result;
    }
    return [];
  };
};

export const getUsers = ({
  isLoadMore = false,
  filter = {},
  skip = 0,
  limit = 50,
  force = false,
}) => {
  return async (dispatch) => {
    if (
      (!(
        store.getState().resources.users &&
        store.getState().resources.users.length
      ) ||
        force) &&
      !store.getState().resources.loading.users
    ) {
      dispatch({ type: SET_LOADING, name: 'users', data: true });
      let result = [];
      const payload = {
        params: {
          skip: skip,
          limit: limit,
        },
      };
      if (filter && Object.keys(filter).length) {
        payload.params.filter = filter;
      }
      const response = await MsAccount.getUsers(payload);
      if (response?.data?.data?.length) {
        result = response.data.data.map((item) => {
          if (item._id) {
            item.id = item._id;
          }
          return item;
        });
      }
      dispatch(changeResourcesData('users', result, isLoadMore));
      dispatch({ type: SET_LOADING, name: 'users', data: false });
      return result;
    }
    return [];
  };
};

export const getRoles = ({
  isLoadMore = false,
  filter = {},
  skip = 0,
  limit = 50,
  force = false,
}) => {
  return async (dispatch) => {
    if (
      (!(
        store.getState().resources.roles &&
        store.getState().resources.roles.length
      ) ||
        force) &&
      !store.getState().resources.loading.roles
    ) {
      dispatch({ type: SET_LOADING, name: 'roles', data: true });
      let result = [];
      const payload = {
        params: {
          skip: skip,
          limit: limit,
          sort: 'name',
        },
      };
      if (filter && Object.keys(filter).length) {
        payload.params.filter = filter;
      }
      const response = await MsAccount.getRoles(payload);
      if (response?.data?.data?.length) {
        result = response.data.data.map((item) => {
          if (item._id) {
            item.id = item._id;
          }
          return item;
        });
      }
      dispatch(changeResourcesData('roles', result, isLoadMore));
      dispatch({ type: SET_LOADING, name: 'roles', data: false });
      return result;
    }
    return [];
  };
};

export const getCountries = ({
  isLoadMore = false,
  filter = {},
  skip = 0,
  limit = 0,
  force = false,
}) => {
  return async (dispatch) => {
    if (
      (!(
        store.getState().resources.countries &&
        store.getState().resources.countries.length
      ) ||
        force) &&
      !store.getState().resources.loading.countries
    ) {
      dispatch({ type: SET_LOADING, name: 'countries', data: true });
      let result = [];
      const payload = {
        params: {
          skip: skip,
          limit: limit,
        },
      };
      if (filter && Object.keys(filter).length) {
        payload.params.filter = filter;
      }
      const response = await MsAccount.getCountries(payload);
      if (response?.data?.data?.length) {
        result = response.data.data.map((item) => {
          if (item._id) {
            item.id = item._id;
          }
          return item;
        });
      }
      dispatch(changeResourcesData('countries', result, isLoadMore));
      dispatch({ type: SET_LOADING, name: 'countries', data: false });
      return result;
    }
    return [];
  };
};

export const getStates = ({
  isLoadMore = false,
  filter = {},
  skip = 0,
  limit = 0,
  force = false,
}) => {
  return async (dispatch) => {
    if (
      (!(
        store.getState().resources.states &&
        store.getState().resources.states.length
      ) ||
        force) &&
      !store.getState().resources.loading.states
    ) {
      dispatch({ type: SET_LOADING, name: 'states', data: true });
      let result = [];
      const payload = {
        params: {
          skip: skip,
          limit: limit,
        },
      };
      if (filter && Object.keys(filter).length) {
        payload.params.filter = filter;
      }
      const response = await MsAccount.getStates(payload);
      if (response?.data?.data?.length) {
        result = response.data.data.map((item) => {
          if (item._id) {
            item.id = item._id;
          }
          return item;
        });
      }
      dispatch(changeResourcesData('states', result, isLoadMore));
      dispatch({ type: SET_LOADING, name: 'states', data: false });
      return result;
    }
    return [];
  };
};

export const getCities = ({
  isLoadMore = false,
  filter = {},
  skip = 0,
  limit = 0,
  force = false,
}) => {
  return async (dispatch) => {
    if (
      (!(
        store.getState().resources.cities &&
        store.getState().resources.cities.length
      ) ||
        force) &&
      !store.getState().resources.loading.cities
    ) {
      dispatch({ type: SET_LOADING, name: 'cities', data: true });
      let result = [];
      const payload = {
        params: {
          skip: skip,
          limit: limit,
        },
      };
      if (filter && Object.keys(filter).length) {
        payload.params.filter = filter;
      }
      const response = await MsAccount.getCities(payload);
      if (response?.data?.data?.length) {
        result = response.data.data.map((item) => {
          if (item._id) {
            item.id = item._id;
          }
          return item;
        });
      }
      dispatch(changeResourcesData('cities', result, isLoadMore));
      dispatch({ type: SET_LOADING, name: 'cities', data: false });
      return result;
    }
    return [];
  };
};

export const getBrands = ({
  isLoadMore = false,
  filter = {},
  skip = 0,
  limit = 0,
  fields = '',
  force = false,
}) => {
  return async (dispatch) => {
    if (
      (!(
        store.getState().resources.brands &&
        store.getState().resources.brands.length
      ) ||
        force) &&
      !store.getState().resources.loading.brands
    ) {
      dispatch({ type: SET_LOADING, name: 'brands', data: true });
      let result = [];
      const payload = {
        params: {
          skip: skip,
          limit: limit,
        },
      };
      if (filter && Object.keys(filter).length) {
        payload.params.filter = filter;
      }
      if (fields) {
        payload.params.fields = fields;
      }
      const response = await MsCatalog.getBrands(payload);
      if (response?.data?.data?.length) {
        result = response.data.data.map((item) => {
          if (item._id) {
            item.id = item._id;
          }
          return item;
        });
        result.unshift({
          id: 'all',
          _id: 'all',
          name: 'All',
        });
      }
      dispatch(changeResourcesData('brands', result, isLoadMore));
      dispatch({ type: SET_LOADING, name: 'brands', data: false });
      return result;
    }
    return [];
  };
};

export const getCustomerClusterRules = ({
  isLoadMore = false,
  filter = {},
  skip = 0,
  limit = 50,
  force = false,
}) => {
  return async (dispatch) => {
    if (
      (!(
        store.getState().resources.clusters &&
        store.getState().resources.clusters.length
      ) ||
        force) &&
      !store.getState().resources.loading.clusters
    ) {
      dispatch({ type: SET_LOADING, name: 'clusters', data: true });
      let result = [];
      const payload = {
        params: {
          skip: skip,
          limit: limit,
        },
      };
      if (filter && Object.keys(filter).length) {
        payload.params.filter = filter;
      }
      const response = await MsAccount.getCustomerClusterRule(payload);
      if (response?.data?.data?.length) {
        result = response.data.data.map((item) => {
          if (item._id) {
            item.id = item._id;
          }
          return item;
        });
      }
      dispatch(changeResourcesData('clusters', result, isLoadMore));
      dispatch({ type: SET_LOADING, name: 'clusters', data: false });
      return result;
    }
    return [];
  };
};

export const getPromotionRules = ({
  isLoadMore = false,
  filter = {},
  skip = 0,
  limit = 50,
  force = false,
}) => {
  return async (dispatch) => {
    if (
      (!(
        store.getState().resources.promotionRules &&
        store.getState().resources.promotionRules.length
      ) ||
        force) &&
      !store.getState().resources.loading.promotionRules
    ) {
      dispatch({ type: SET_LOADING, name: 'promotionRules', data: true });
      let result = [];
      const payload = {
        params: {
          skip: skip,
          limit: limit,
        },
      };
      if (filter && Object.keys(filter).length) {
        payload.params.filter = filter;
      }
      const response = await MsOrder.getPromotionRules(payload);
      if (response?.data?.data?.length) {
        result = response.data.data.map((item) => {
          if (item._id) {
            item.id = item._id;
          }
          return item;
        });
      }
      dispatch(changeResourcesData('promotionRules', result, isLoadMore));
      dispatch({ type: SET_LOADING, name: 'promotionRules', data: false });
      return result;
    }
    return [];
  };
};

export const getBrandLetters = () => {
  return async (dispatch) => {
    if (
      !store.getState().resources.brandLetters?.alphabets?.length &&
      !store.getState().resources.loading.brandLetters
    ) {
      dispatch({ type: SET_LOADING, name: 'brandLetters', data: true });
      const letters = [];
      const letterData = [];
      const letterHeight = 44;
      const response = await MsCatalog.getBrandsLetter();
      if (response?.data?.data && Object.keys(response.data.data)?.length) {
        const res = response.data.data;
        let size = 0;
        const keys = Object.keys(res);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          letters.push({
            label: key,
            size: size,
          });
          letterData.push({
            name: key,
            size: size,
            elementId: `alphabet-letter-${key}`,
          });
          size += letterHeight;
          if (res[key]?.length) {
            for (let j = 0; j < res[key].length; j++) {
              const item = res[key][j];
              letterData.push({
                ...item,
                id: item._id,
              });
              size += letterHeight;
            }
          }
        }
      }
      const finalResponse = {
        alphabets: letters,
        data: letterData,
      };
      dispatch(changeResourcesData('brandLetters', finalResponse, false));
      dispatch({ type: SET_LOADING, name: 'brandLetters', data: false });
      return finalResponse;
    }
    return [];
  };
};
